import React, { CSSProperties, ReactElement } from "react";
import { Slider, SliderSingleProps } from "antd";
import "./index.less";

interface baseSliderProps {
    bg_track?: string;
    bg_handle?: string;
}

export type SettingSliderProps = SliderSingleProps & baseSliderProps;

export const SettingSlider: React.FC<SettingSliderProps> = ({
    className,
    bg_track = "#6cbf00",
    bg_handle = "#6cbf00",
    ...props
}): ReactElement => {
    return (
        <Slider
            className={`Setting-Slider ${className}`}
            max={100}
            min={0}
            step={1}
            style={{ "--track-bg": bg_track, "--handle-bg": bg_handle } as CSSProperties}
            tabIndex={-1}
            {...props}
        />
    );
};
